export const CODE_LENGTH = 4;
export const CHALLENGE_NAME = 'CUSTOM_CHALLENGE';
export const AUTH_FLOW = 'CUSTOM_AUTH';
export const REFRESH_TOKEN_AUTH = 'REFRESH_TOKEN_AUTH';
export const COUNT_TO_RESEND_CODE = 60;
export const ASYNC_STORAGE_GUEST_PORTAL_TOKEN_KEY = 'GuestPortalToken';
export const ASYNC_STORAGE_REGISTRATION_INFO_KEY = 'registrationInfo';
export const ASYNC_STORAGE_REDIRECT_INFO_KEY = 'redirectInfo';
